export default __webpack_public_path__ + "static/media/serviceRequest.3f52daab.svg";